import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { slackDaysFormatter } from '../../../utils/ganttFormatters';


const totalSlackCol = (gantt, t) => {
  const name = 'totalSlack';
  const isVisible = isColumnVisibleByDefault(name);
  const navigatorLang = navigator.language || navigator.userLanguage;

  return {
    name,
    label: t('gantt.columns.totalSlack', 'Holgura Total'),
    align: 'center',
    resize: true,
    width: '*',
    template: function (activity) {
      const isOdd = gantt.oddColsConfig?.totalSlack || false;
      const hasChild = gantt.hasChild(activity.id);

      const { enFormatSlack, otherFormatSlack } = slackDaysFormatter(activity, gantt);

      if (gantt.isSummaryTask(activity)) {
        return `<div class="${isOdd ? 'odd-col' : 'non-odd-col'}"> </div>`;
      }
      
      const displaySlack = navigatorLang.includes('en') ? enFormatSlack : otherFormatSlack;

      return `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="font-weight: ${hasChild ? 600 : 100};">
          ${displaySlack}
        </div>
      `;
    },
    hide: !isVisible,
    data_type: 'number',
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → N', 'N → 1'],
    filterable: true,
  };
};

export default totalSlackCol; 